import React from 'react'
import Address from './Address'
import { compose } from '@cbgms/base/utils/compose'
import { WithTranslation, withTranslation } from 'react-i18next'
import { Divider, Typography } from '@mui/material'

interface IOwnProps {
  form: string
  prefix?: string
  inverted?: boolean
  validate?: boolean
  showVisitLatitudeLongitude?: boolean
  showPostalLatitudeLongitude?: boolean
}

interface AddressesProps extends IOwnProps, WithTranslation {}

const enhance = compose<AddressesProps, IOwnProps>(withTranslation())

class Addresses extends React.Component<AddressesProps> {
  static defaultProps = {
    prefix: ''
  }

  render() {
    const { prefix, validate, form, t, showVisitLatitudeLongitude, showPostalLatitudeLongitude } = this.props

    return (
      <React.Fragment>
        <Typography variant='h5' sx={{ mb: 2 }}>
          {t('global.visit_address')}
        </Typography>
        <Address prefix={`${prefix}Visitor`} validate={validate} form={form} showLatitudeLongitude={showVisitLatitudeLongitude} />

        <Divider sx={{ my: 1 }} />

        <Typography variant='h5' sx={{ mb: 2 }}>
          {t('global.postal_address')}
        </Typography>
        <Address prefix={`${prefix}Postal`} form={form} showLatitudeLongitude={showPostalLatitudeLongitude} />
      </React.Fragment>
    )
  }
}

export default enhance(Addresses)
